export type TFrequency = { name: string; value: "MONTHLY" | "QUARTERLY" | "SEMIANNUAL" | "ANNUAL" };

export const paymentFrequencyOptions: TFrequency[] = [
  { name: "Mensal", value: "MONTHLY" },
  { name: "Trimestral", value: "QUARTERLY" },
  { name: "Semestral", value: "SEMIANNUAL" },
  { name: "Anual", value: "ANNUAL" },
];
